/* Feature Flags */
export const FEATURE_NEW_NOTICES = 'feature_new_notices'
export const FEATURE_NEW_DASHBOARD = 'feature_new_dashboard'
export const FEATURE_WHATS_NEW = 'feature_whats_new'
export const FEATURE_EVENT_DATE_TABLE_RESTRICTION =
  'feature_event_date_table_restriction'
export const FEATURE_GCP_MIGRATION_ENABLED = 'IS_GCP_MIGRATION_ENABLED'
